module.exports = "<div if=\"$ctr.svgString\" class=\"custom-query-preview\"  ng-bind-html=\"$ctrl.svgString\"></div>"